import ImportInstallationsContent from "../modules/installation/pages/ImportInstallations/nl";
import ImportCompressorsContent from "../modules/installation/pages/ImportCompressors/fr";
import ImportSitesContent from "../modules/company/pages/ImportSites/nl";
import ImportClientsContent from "../modules/company/pages/ImportClients/nl";
import PrivacyPolicy from "../modules/common/pages/PrivacyPolicy/nl";
import CGU from "../modules/common/pages/CGU/nl";

export default {
  ImportInstallationsContent,
  ImportCompressorsContent,
  ImportSitesContent,
  ImportClientsContent,
  PrivacyPolicy,
  CGU,
};
